import { ReactElement } from "react";
import {
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Alert,
  Box,
} from "@mui/material";
import { Info as InfoIcon } from "@mui/icons-material";

export interface WorkflowInfoProps {
  className?: string;
}

const WorkflowInfo = ({ className = "" }: WorkflowInfoProps): ReactElement => {
  // TODO: Make this component type-specific based on project type
  // Currently only supports single-cell data, but should be dynamic based on:
  // - Project type from types/dataTypes.ts
  // - Different workflow steps for different data types
  // - Type-specific file format requirements
  return (
    <Box className={`p-6 ${className}`}>
      <div className="flex items-center justify-center mb-6">
        <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center mr-3">
          <InfoIcon className="text-green-600" sx={{ fontSize: 24 }} />
        </div>
        <Typography variant="h5" className="text-gray-800 font-bold">
          Workflow Instructions
        </Typography>
      </div>

      <div className="space-y-4">
        <List dense className="py-0">
          <ListItem className="px-0">
            <ListItemIcon className="min-w-0 mr-3">
              <div className="w-2 h-2 rounded-full bg-gray-400 mt-2" />
            </ListItemIcon>
            <ListItemText
              primary="Each step in this workflow must be executed in sequence from Quality Control to Clustering."
              className="text-gray-700"
            />
          </ListItem>
          <ListItem className="px-0">
            <ListItemIcon className="min-w-0 mr-3">
              <div className="w-2 h-2 rounded-full bg-gray-400 mt-2" />
            </ListItemIcon>
            <ListItemText
              primary="The results are not saved individually per step."
              className="text-gray-700"
            />
          </ListItem>
          <ListItem className="px-0">
            <ListItemIcon className="min-w-0 mr-3">
              <div className="w-2 h-2 rounded-full bg-gray-400 mt-2" />
            </ListItemIcon>
            <ListItemText
              primary="If you skip a step or go back, you must rerun all steps forward again."
              className="text-gray-700"
            />
          </ListItem>
          <ListItem className="px-0">
            <ListItemIcon className="min-w-0 mr-3">
              <div className="w-2 h-2 rounded-full bg-gray-400 mt-2" />
            </ListItemIcon>
            <ListItemText
              primary="The only optional step is Doublet Detection – you may skip it if you wish"
              className="text-gray-700"
            />
          </ListItem>
        </List>

        <Alert severity="info" className="mt-6">
          <Typography variant="body2" className="text-gray-600">
            <strong>Note:</strong> Currently this workflow is optimized for
            single-cell RNA sequencing data. Support for other data types will
            be added in future updates.
          </Typography>
        </Alert>
      </div>
    </Box>
  );
};

export default WorkflowInfo;
